import {Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

const KEY = {
    BACK_SPACE: 8,
    RETURN: 13,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ComboSearchComponent),
    multi: true
};

@Component({
    selector: 'tfl-bo-combo-search',
    template: require('./combo-search.component.html'),
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]

})
export class ComboSearchComponent implements ControlValueAccessor {

    selected: any = undefined;

    @Input() id: string;
    @Input() items: any[];
    @Input() name: string;
    @Input() disabled: boolean;
    @Input() searchTimeout: number = 350;
    @Input() maxSearchLength: number = 100;

    @Input() placeHolder: string;
    @Input() value: string = "";
    @Input() emptySearchResultText: string;
    @Input() nameDescription: string = 'name';
    @Input() isFirstLetter: boolean = false;

    onChange: EventEmitter<any> = new EventEmitter<any>();
    onTouchedCallback: EventEmitter<any> = new EventEmitter<any>();
    @Output() searchText: EventEmitter<string> = new EventEmitter<string>();

    hasFocus: boolean = false;
    lockFocus: boolean = true;
    searched: boolean = false;

    modelValue: string;
    private tout;
    private toutHiddenList;
    private toutHiddenTimeout: number = 200;

    @ViewChild('searchInput') private searchInput: ElementRef;
    @ViewChild('listOption') private listOption: ElementRef;

    manageList(event: KeyboardEvent) {
        let key: number = (event.keyCode || event.which),
            keys: number[] = [KEY.RETURN, KEY.UP, KEY.DOWN];

        if (this.isOneKeyOf(keys, key)) {
            event.preventDefault();
        }

        if (key == KEY.RETURN) {
            this.onSelect(this.selected);
        }

        let index = this.items.indexOf(this.selected);
        if (key == KEY.UP && index - 1 >= 0) {
            this.onSelect(this.items[--index], false);
        } else if (key == KEY.DOWN && index < this.items.length - 1) {
            this.onSelect(this.items[++index], false);
        }

        if (key == KEY.UP) {
            this.scrollTop();
        } else if (key == KEY.DOWN) {
            this.scrollDown();
        }
    }

    showList() {
        clearTimeout(this.toutHiddenList);

        this.hasFocus = true;
        this.lockFocus = false;

        setTimeout(() => {
            if (this.items.indexOf(this.selected) > -1) {
                this.scrollTop();
            }
        });
    }

    hideList(instantly: boolean = false) {
        clearTimeout(this.toutHiddenList);

        if (instantly) {
            this.hasFocus = false;
            this.lockFocus = false;
        } else {
            let hideInstantly = () => this.hideList(true);
            this.toutHiddenList = setTimeout(hideInstantly, this.toutHiddenTimeout);
        }
    }

    search(text: string, event: KeyboardEvent) {
        let keyCode = event.keyCode || event.which;

        if (keyCode == KEY.RETURN) {
            event.preventDefault();
        } else {
            clearTimeout(this.tout);
            this.onChange.emit(undefined);
            if ((keyCode > 46 && keyCode < 112) || keyCode == KEY.BACK_SPACE) {
                this.tout = setTimeout(() => {
                    this.searchText.emit(text);
                    this.searched = true;
                }, this.searchTimeout);
            }
        }
    }

    onSelect(item: any, autoFire: boolean = true) {
        if (item == null) return;

        this.selected = item;
        this.onChange.emit(item);

        if (this.searchInput) {
            this.searchInput.nativeElement.value = item[this.nameDescription] || '';
        }

        if (autoFire) {
            this.hideList(true);

            if (this.searchInput) {
                this.searchInput.nativeElement.blur();
            }
        }
    }

    writeValue(item: any): void {
        this.selected = item;

        if (!!this.searchInput && !!item) {
            this.searchInput.nativeElement.value = item[this.nameDescription] || '';
        }
    }

    registerOnChange(fn: any): void {
        this.onChange.subscribe(fn);
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback.subscribe(fn);
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    private scrollTop() {
        let index = this.items.indexOf(this.selected);
        if (this.listOption && this.listOption.nativeElement.children[index]) {
            this.listOption.nativeElement.scrollTop = this.listOption.nativeElement.offsetTop;
        }
    }

    private scrollDown() {
        let index = this.items.indexOf(this.selected);
        if (this.listOption && this.listOption.nativeElement.children[index]) {
            let {offsetTop, offsetHeight} = this.listOption.nativeElement.children[index];
            this.listOption.nativeElement.scrollTop = offsetTop + offsetHeight - this.listOption.nativeElement.offsetHeight;
        }
    }

    private isOneKeyOf(keys: number[] = [], code: number): boolean {
        return !!keys.filter(x => x == code).length;
    }

    getType(){
        return this.isFirstLetter? 'first-letter': 'text';
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/combo-search/combo-search.component.ts